import { render, staticRenderFns } from "./contractStats.vue?vue&type=template&id=38e4b828&scoped=true"
import script from "./contractStats.vue?vue&type=script&lang=js"
export * from "./contractStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e4b828",
  null
  
)

export default component.exports